/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { exportTargetMappingCreate } from '../../axios/exportTargetMappingCreate'
import type {
	ExportTargetMappingCreateError,
	ExportTargetMappingCreateRequest,
	ExportTargetMappingCreateResponse,
} from '../../types/ExportTargetMappingCreate'

export const exportTargetMappingCreateMutationKey = () => [{ url: '/export-target-mappings' }] as const

export type ExportTargetMappingCreateMutationKey = ReturnType<typeof exportTargetMappingCreateMutationKey>

export type ExportTargetMappingCreateVariables = {
	data: ExportTargetMappingCreateRequest
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::create */
export function useExportTargetMappingCreate<TContext = unknown>(
	options?: UseMutationOptions<
		ExportTargetMappingCreateResponse,
		AxiosError<ExportTargetMappingCreateError>,
		ExportTargetMappingCreateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: exportTargetMappingCreateMutationKey(),
		mutationFn: ({ data }: ExportTargetMappingCreateVariables) =>
			exportTargetMappingCreate(data, config).then(res => res.data),
		...options,
	})
}
